'use client'
import SignInWithGoogle from '@/components/ui/signup-with-google'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import { Alert, Spinner } from '@material-tailwind/react'
import { useRouter, useSearchParams } from 'next/navigation'
import { useRef, useState } from 'react'

import Link from 'next/link'
import './style.scss'
export default function Login() {
  const query = useSearchParams()
  const role = query.get('role')
  return (
    <div
      className="bg-no-repeat bg-contain bg-right-bottom auth-screen"
      style={{
        backgroundImage:
          "url('https://ai-forge.vaionex.cloud/_next/image?url=https%3A%2F%2Fs3-alpha-sig.figma.com%2Fimg%2F8d27%2Fe41b%2F39c5f7637e6b6518e75e43af2beead31%3FExpires%3D1708905600%26Key-Pair-Id%3DAPKAQ4GOSFWCVNEHN3O4%26Signature%3DVvNfH9IyF9bAj9uaZG5fxNvDJtP3qTiQ7ge9QvvEyzOKNolT3ZDhs7pTwSauaNWinU~zvj4QU3AX1btSHq9qgwddQZkxC9TpJ17Ur3J8mE41uD8YFUFKPEMzJKNU4D98HZPLwBdzIM6iO6PwKlkHIZnAR3Gda3-UEnGp3VB9dzQddnGwTPnriTXaQW~4QUs5g6hqC0HbfTx4f29W51fjf9Ougv-xfC2rTvTgjCyTYJrKuO1ted8nOjCBlS43qvqZOhZ~ix7heD9g-ZaVJu0zWr0j0YcEP5eULSwcJIXHKdYG50gJ30PYaGr4Xns0C7ebvAymu2hcDjJ5BXQgVZWFNA__&w=1200&q=75')",
      }}
    >
      <div className="  relative max-w-[75rem] w-full mx-auto ">
        <LoginPage role={role} />
        {/* <div className="z-10 auth-desc absolute bottom-[140px] right-[20px] p-[32px] max-w-[446px] ">
          <h2 className="text-left text-white text-[18px] font-[600] ">
            Exclusive Content Access
          </h2>
          <p className="text-[#B8BEC9] text-sm font-normal max-w-[600px] ">
            Gain immediate access to mentors, investors, and personalized tools{' '}
            like an inbox, playbooks, and a databoard, all designed to
            accelerate your success. This suite of features supports your
            growth, networking, and learning, equipping you with everything
            needed to thrive in our ecosystem.
          </p>
        </div> */}
      </div>
    </div>
  )
}

const LoginPage = ({ role }) => {
  const [loading, setLoading] = useState(false)
  const { signUp } = useAuth()
  const emailRef = useRef(null)
  const passwordRef = useRef(null)
  const confirmPasswordRef = useRef(null)
  const [errorMsg, setErrorMsg] = useState('')
  const [msg, setMsg] = useState('')
  const getURL = () => {
    let url =
      process?.env?.NEXT_PUBLIC_MAIN_URL ?? // Set this to your site URL in production env.
      process?.env?.NEXT_PUBLIC_VERCEL_URL ?? // Automatically set by Vercel.
      'http://localhost:3000/'
    // Make sure to include `https://` when not localhost.
    url = url.includes('http') ? url : `https://${url}`
    // Make sure to include a trailing `/`.
    url = url.charAt(url.length - 1) === '/' ? `${url}role` : `${url}/role`
    return url
  }
  const register = async (email, password) => {
    const res = await signUp({
      email,
      password,
      emailRedirectTo: getURL(),
      role,
    })
    return res
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMsg('')
    if (
      !passwordRef.current?.value ||
      !emailRef.current?.value ||
      !confirmPasswordRef.current?.value
    ) {
      setErrorMsg('Please fill in all the fields')
      return
    }

    if (passwordRef.current.value !== confirmPasswordRef.current.value) {
      setErrorMsg("Passwords doesn't match")
      return
    }
    try {
      setErrorMsg('')
      setLoading(true)
      const response = await register(
        emailRef.current.value,
        passwordRef.current.value,
      )
      // console.log("test", response)
      const error = response?.error
      const data = response?.data
      if (
        !error &&
        data &&
        data.user &&
        data.user.identities &&
        data.user.identities.length === 0
      ) {
        setErrorMsg('User already exists')
        setLoading(false)
      } else if (!error && data) {
        setMsg(
          'Registration Successful. Check your email to confirm your account',
        )
      } else if (error) {
        const isLimit = error?.message === 'Email rate limit exceeded'
        console.error('error11', error)
        setErrorMsg(
          isLimit
            ? error?.message + '. Please try later'
            : error?.message || 'Error in Creating Account',
        )
      }
    } catch (error) {
      setLoading(false)
      const isLimit = error?.message === 'Email rate limit exceeded'
      console.error('error22', error)
      setErrorMsg(
        isLimit
          ? error?.message + '. Please try later'
          : error?.message || 'Error in Creating Account',
      )
    }
  }

  return (
    <div className="flex min-h-full flex-col w-full sm:w-[410px]  py-12 px-8 sm:px-0  pb-32">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="text-left text-white text-[36px] font-[600] ">
          Sign Up
        </h2>
        <p className="text-[#98A2B3] text-base font-normal  ">
          Ignite the Spark of AI Creativity
        </p>
      </div>

      <div className="mt-0 sm:mx-auto w-full sm:max-w-md">
        <div className="bg-inherit py-8  shadow sm:rounded-lg ">
          <form className="space-y-6" action="#" method="POST">
            <div className="p-[10px_14px] gap-2  h-[72px] bg-[#101011] border border-[#292A2D] shadow-xs rounded-xl">
              <label
                htmlFor="email"
                className="text-[#98A2B3] text-sm font-[400] "
              >
                Email
              </label>
              <input
                id="email"
                ref={emailRef}
                name="email"
                type="email"
                autoComplete="email"
                required
                className=" bg-inherit w-full rounded-md border-0 p-0 h-[20px] text-white placeholder:text-[#98A2B3] text-base font-normal focus:ring-0 ring-0"
              />
            </div>
            <div className="p-[10px_14px] gap-2  h-[72px] bg-[#101011] border border-[#292A2D] shadow-xs rounded-xl">
              <label
                htmlFor="password"
                className="text-[#98A2B3] text-sm font-[400] flex items-center justify-between "
              >
                Password{' '}
              </label>
              <input
                id="password"
                ref={passwordRef}
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className=" bg-inherit w-full rounded-md border-0 p-0 h-[20px] text-white placeholder:text-[#98A2B3] text-base font-normal focus:ring-0 ring-0"
              />
            </div>
            <div className="p-[10px_14px] gap-2  h-[72px] bg-[#101011] border border-[#292A2D] shadow-xs rounded-xl">
              <label
                htmlFor="confirm-password"
                className="text-[#98A2B3] text-sm font-[400] flex items-center justify-between "
              >
                Confirm Password
              </label>
              <input
                id="confirm-password"
                ref={confirmPasswordRef}
                name="confirm-password"
                type="password"
                autoComplete="current-password"
                required
                className=" bg-inherit w-full rounded-md border-0 p-0 h-[20px] text-white placeholder:text-[#98A2B3] text-base font-normal focus:ring-0 ring-0"
              />
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3 ">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-[16px] w-[16px]  text-blue-600 rounded bg-white border border-white cursor-pointer"
                />
                <label
                  htmlFor="remember-me"
                  className="text-[#98A2B3] text-sm font-[500] cursor-pointer ml-2 lg:ml-0 "
                >
                  Remember this device
                </label>
              </div>

              {/* <div className="text-sm">
                <a
                  href="/resetpassword"
                  className="text-blue-600 text-sm font-[600] "
                >
                  Forgot password
                </a>
              </div> */}
            </div>
            {errorMsg && (
              <Alert
                variant="danger"
                className="buttonstyle"
                onClose={() => setErrorMsg('')}
              >
                {errorMsg}
              </Alert>
            )}
            {msg && (
              <Alert
                onClose={() => setMsg('')}
                variant="success"
                className="buttonstylesuccess"
              >
                {msg}
              </Alert>
            )}
            <div>
              <button
                disabled={loading}
                onClick={handleSubmit}
                type="button"
                className="flex w-full justify-center rounded-[32px]
                 bg-blue-600 py-2 px-3 text-sm font-semibold gap-4
                  text-white shadow-sm hover:bg-blue-500 focus-visible:outline
                   focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600
                   "
              >
                Get started
                {loading && <Spinner className="w-5 h-5 mt-1" />}
              </button>
            </div>
          </form>
          <SignInWithGoogle isLogin={true} role={role} />
          <div className="flex items-center justify-center gap-1 text-sm mt-8">
            <div className="text-[#98A2B3] text-sm ">
              Already have an account?
            </div>
            <Link
              href="/login"
              className="font-[600] text-white text-sm hover:text-blue-500"
            >
              Log in
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
